import $ from "jquery";
import { $body, CLEAN_URL } from '../Constants';
import HtmlElement from './HtmlElement';

/**
 * SlideIn
 */
const SlideIn = (() => {

	/**
	 * Selector
	 */
	const Selector = {
		GENERAL: '.callus',
		SLIDE_IN_CONTENT: '.content',
		SLIDE_IN_BUTTON: '.button',
		SLIDE_IN_BUTTON_ICON: '.button > i',
		USERLIKE: '#userlikeCustomTab'
	};

	/**
	 * SlideIn
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class SlideIn extends HtmlElement {

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {

			if (this.$element.length) {

				let $typeNum = 3418; // Contact slide-in (Loeschwasser)
				let $promotion = false;
				if (this.$element.hasClass('promotion')) {
					$typeNum = 3417; // Promotion slide-in
					$promotion = true;
				}

				$.ajax({
					type: 'GET',
					url: CLEAN_URL + '?type=' + $typeNum,
					success: (response) => {
						if (response) {
							this.$element.html(response);

							let $userLike = this.$element.find(Selector.USERLIKE),
								$slideInContent = this.$element.find(Selector.SLIDE_IN_CONTENT),
								$slideInButton = this.$element.find(Selector.SLIDE_IN_BUTTON),
								$slideInButtonIcon = this.$element.find(Selector.SLIDE_IN_BUTTON_ICON),
								$slideInClosedIcon = 'fa-percent',
								$slideInOpenIcon = 'fa-chevron-right',
								$slideInHeight = 430;

							// Set height
							if (!$promotion) {
								$slideInHeight = 355;
								$slideInClosedIcon = 'fa-user-headset';
							}
							$slideInContent.css('height', $slideInHeight);

							$slideInButton.on('click', () => {
								this.$element.toggleClass('open');

								if (this.$element.hasClass('open')) {
									$slideInButtonIcon.removeClass($slideInClosedIcon);
									$slideInButtonIcon.addClass($slideInOpenIcon);
								} else {
									$slideInButtonIcon.removeClass($slideInOpenIcon);
									$slideInButtonIcon.addClass($slideInClosedIcon);
								}
							});

							if ($userLike.length) {
								$userLike.on('click', () => {
									if (this.$element.hasClass('open')) {
										$slideInButton.trigger('click');
									}
								});
							}

							// Nur oeffnen, falls es nicht schon offen ist
							setTimeout(() => {
								if (!this.$element.hasClass('open')) {
									$slideInButton.trigger('click');

									setTimeout(() => {
										if (this.$element.hasClass('open')) {
											$slideInButton.trigger('click');
										}
									}, 5000);
								}
							}, 10);
						}
					}
				});
			}
		}
	}

	return SlideIn._getElement($body.find(Selector.GENERAL), SlideIn);
})();

export default SlideIn;
